/* eslint-disable no-prototype-builtins */
import { ScriptLoader } from 'script-loader';
import { isLogin } from 'utils';
import { IPsKeyManagerInjectable } from './interface';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import { OnlineEditServices } from '@src/slide/domain/slide-app/scenes/online/core/online-edit-services.core';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';

export default class PsKeyManager {
    private injectable: IPsKeyManagerInjectable;
    public constructor(injectable: IPsKeyManagerInjectable) {
        this.injectable = injectable;
        this.registerPskeyErrorListener();
        // 10分钟check一次
        setInterval(this.checkUserInfo, 10 * 60 * 1000);
        // pskeyError监听
        eventBus.on(EventKeys.PSKEY_ERROR, () => {
            // 本地数据为已登录的情况下收到登录状态错误,提示登录失效
            this.handlePskeyError();
        });
    }

    private checkUserInfo = async () => {
        const apiService = await OnlineEditServices.OnlineApiService.promise();
        apiService.getUserInfo()
            .then(this.onCheckUserInfo)
            .catch((err) => {
                window.log?.error(`checkUserInfo fail:${JSON.stringify(err)}`);
            });
    };

    private onCheckUserInfo = (res) => {
        if (res?.data) {
            if (res.data.retcode !== 0) {
                this.isDocAppOrLogin();
            }
        } else {
            window.log?.error(`checkUserInfo fail:${JSON.stringify(res)}`);
        }
    };

    private isDocAppOrLogin() {
        const isTencentDocsApp = !!window.navigator.userAgent.match(/(TencentDocs)/i);
        if (isTencentDocsApp) {
            setTimeout(() => {
                window.mqq?.invoke('docx', 'logoutAccount');
            }, 100);
            return;
        }
        if (isLogin()) {
            this.showPskeyErrorTips(); // 统一模态提示
        } // 未登录会出【立即登录】banner，无需弹出 tip-toast。
    }

    private registerPskeyErrorListener = () => {
        // @ts-ignore
        ScriptLoader.listen('TX-LOGIN-PSKEY-EXPIRED', this.onListenPSKeyExpired);
    };

    private onListenPSKeyExpired = (opt) => {
        let pureURL = 'unknown url';
        let retcode = 0;
        if (opt.detail) {
            if (opt.detail.hasOwnProperty('url')) {
                const { url } = opt.detail;
                if (typeof url === 'string') {
                    const compURL = url.split('?');
                    pureURL = compURL[0];
                }
            }
            if (opt.detail.hasOwnProperty('code')) {
                retcode = opt.detail.code;
            }
            window.log.error(`ptt listen onPskeyError(${pureURL}) = ${retcode}`);
        } else {
            window.log.error('ptt listen onPskeyError opt.detail = null');
        }
        this.onPskeyError(pureURL, retcode);
    };

    private onPskeyError = (pureURL, retcode) => {
        tdw({
            opername: 'doc_account_web',
            module: 'account_info',
            action: 'log_expired',
            // ver6: 需上报监听登录态过期或失效时的错误码
            ver6: retcode,
        });
        if (pureURL.indexOf('user_info') < 0) {
            this.checkUserInfo();
        } else {
            this.isDocAppOrLogin();
        }
    };

    private showPskeyErrorTips() {
        eventBus.emit(EventKeys.PSKEY_ERROR);
    }
    private handlePskeyError = () => {
        if (!isLogin()) {
            window.log.info('handlePskeyError not logged in');
        }
        this.injectable.handlePskeyError();
    };
}
